/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import Dot from "../../../../icons/Dot";
import MapPin from "../../../../icons/MapPin";
import Heart from "../../../../icons/Heart";
import LikedIcon from "../../../../icons/LikedIcon";

import WhatsAppIcon2 from "../../../../icons/WhatsAppIcon2";
import PhoneIcon from "../../../../icons/PhoneIcon";
import ShareIcon from "../../../../icons/ShareIcon";
import { Button } from "../../../../shadcn/components/ui/button";
import { DateTime } from "luxon";
import {
  amountFormatter,
  getWatermarkedImgixUrl,
  shortlistProperty,
} from "services";
import { useSelector } from "react-redux";

interface PDHeadingSectionProps {
  propertyData: any;
  setAuthModelOpen: any;
  setAcknowledgementOpen: any;
  setAcknowledgementDetails: any;
  titleName?: string;
  propertyImages?: any[];
}

const PDHeadingSection: React.FC<PDHeadingSectionProps> = ({
  propertyData,
  setAuthModelOpen,
  setAcknowledgementOpen,
  setAcknowledgementDetails,
  titleName = "Contact Officer",
  propertyImages,
}) => {
  const [open, setOpen] = useState(false);

  const {
    reserve_price,
    listing_id,
    city,
    area,
    state,
    asset,
    sub_asset_type,
    auction_start_date_time,
    uuid,
    interested_count,
    property_date_type,
    sub_asset_type_details,
    images,
  } = propertyData;

  const shortlistedProperties = useSelector(
    (state: any) => state.auth?.user?.profile?.meta?.shortlisted_properties,
  );
  const userToken = useSelector((state: any) => state.auth.accessToken);

  const formatDate = (dateString: string) => {
    const date = DateTime.fromISO(dateString);
    return date.isValid ? date.toFormat("dd LLLL yyyy") : "Invalid date";
  };

  const handleShortListed = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (userToken) {
      try {
        await shortlistProperty(uuid, interested_count);
      } catch (error) {
        console.error("Error shortlisting property:", error);
      }
    } else {
      setAuthModelOpen(true);
      console.log("Open modal for login");
    }
  };
  const contactOfficerHandler = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (userToken) {
      setOpen(true);
    } else {
      setAuthModelOpen(true);
    }
  };

  const handleWhatsappClick = () => {
    const clientNumber = "+918370969696";
    const baseUrl = window.location.href.split("/").filter(Boolean)[1];
    const link = `https://${baseUrl}/private-properties/${listing_id}`;
    const whatsappMsg = `Hi Auctionbazaar,\n\nI am interested in knowing more about this property\n\n${link}`;

    window.open(
      `https://wa.me/${clientNumber}?text=${encodeURI(whatsappMsg)}`,
      "_blank",
    );
  };

  const [showCopiedPopup, setShowCopiedPopup] = useState(false);

  return (
    <section>
      {/* Property Image for Mobile */}
      <div className="clip-path-webClipPolygonTopLeft mt-4 relative lg:hidden ">
        <img
          src={
            propertyImages && propertyImages?.length > 0
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${propertyImages?.[0].uuid}`,
                )
              : sub_asset_type_details?.images?.[0]?.uuid
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${sub_asset_type_details?.images?.[0].uuid}`,
                )
              : "/../newPropertyImage.png"
          }
          alt="property image"
          className="w-full h-[228px] sm:h-[320px] object-cover"
        />
        <div
          className="px-3 py-2 rounded cursor-pointer absolute z-1 top-0 right-0"
          onClick={handleShortListed}
        >
          {shortlistedProperties?.includes(uuid) ? (
            <LikedIcon />
          ) : (
            <Heart border="#fff" />
          )}
        </div>
      </div>

      {/* Property Details */}
      <div className="mt-4 lg:flex w-full lg:justify-between">
        <div className="lg:flex">
          {/* Price and ID */}
          <div className="flex justify-between items-center lg:items-start lg:border-r-[1px] lg:pr-5 lg:gap-4">
            <div className="flex lg:flex-col gap-2 lg:gap-0">
              <div className="text-2xl lg:text-[32px] font-bold text-brand-textBlack">
                ₹ {amountFormatter(reserve_price)}
              </div>
              <div className="uppercase font-semibold text-xs lg:text-sm text-brand-headingBlue lg:mt-2 self-end lg:self-start">
                {area ? `@${(reserve_price / area)?.toFixed(2)} PER SQ FT` : ""}
              </div>
            </div>
            <div className="py-1 px-3 border-[1px] rounded-full border-brand-textLightGrey flex items-center lg:mt-1">
              <Dot />
              <span className="text-[10px] lg:text-sx pl-2 font-normal uppercase">
                ID {listing_id}
              </span>
            </div>
          </div>

          {/* Asset Details */}
          <div className="mt-4 lg:mt-0 lg:pl-5 lg:max-w-[400px]">
            <div className="capitalize text-xl lg:text-2xl text-brand-textLightGrey">
              {`${asset.name} / ${sub_asset_type.name}`}
            </div>
            <div className="flex pt-1 items-center">
              <MapPin />
              <span className="px-1 text-xs lg:text-sm text-brand-textGrey capitalize">
                {`${city.name}, ${state.name}`}
              </span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="hidden lg:flex gap-5 items-center">
          <div
            className="px-3 py-2 bg-[#F7F7F7] rounded cursor-pointer"
            onClick={handleShortListed}
          >
            {shortlistedProperties?.includes(uuid) ? <LikedIcon /> : <Heart />}
          </div>
          <div
            className="px-3 py-2 bg-[#F2FFEA] rounded cursor-pointer"
            onClick={handleWhatsappClick}
          >
            <WhatsAppIcon2 />
          </div>
        </div>
      </div>

      {/* Contact and Share Buttons */}
      <div className="flex gap-4 sm:gap-8 mt-5 lg:mt-7">
        <a href="#px-12234" className="scroll-smooth lg:hidden">
          <Button className="px-4 sm:px-7">
            <PhoneIcon width={16} height={16} />
            <p className="px-1">{titleName}</p>
          </Button>
        </a>
        <a href="#px-12235" className="scroll-smooth hidden lg:inline-block">
          <Button className="px-0 sm:px-7">
            <PhoneIcon width={16} height={16} />
            <p className="px-4">{titleName}</p>
          </Button>
        </a>

        <Button
          className="bg-white text-black border px-7 hover:bg-white"
          onClick={() => {
            setShowCopiedPopup(true);
            setTimeout(() => {
              setShowCopiedPopup(false);
            }, 2000);
            if (document.hasFocus()) {
              window.navigator.clipboard.writeText(window.location.href);
            }
          }}
        >
          <ShareIcon />
          <p className="pl-1">Share</p>
        </Button>
      </div>
      {showCopiedPopup && (
        <div
          className={
            "absolute text-xs lg:text-base z-50 bottom-1/2 mt-2 left-1/2 -translate-x-1/2 h-fit w-fit py-2 px-8 border border-white rounded-lg bg-black text-center text-white transition-all " +
            (showCopiedPopup ? "opacity-75" : "opacity-0")
          }
        >
          Copied to Clipboard
        </div>
      )}
    </section>
  );
};

export default PDHeadingSection;
